import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { getBrowserName, isLoggedIn } from "config/utils";

export const getRefundPaymentLinkUserDetails = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-refund-course-user-details?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};

export const addRefundDetails = async (data = {}) => {
  const token = isLoggedIn();
  return decryptData(
    await axios.post(`/add-refund-details`, {
      reqData: encryptData({
        ...data,
        platformType: getBrowserName(),
        access_token: token,
      }),
    })
  );
};

export const updateBankAccountDetails = async (data = {}) => {
  const token = isLoggedIn();
  return decryptData(
    await axios.post(`/update-bank-account-details`, {
      reqData: encryptData({
        ...data,
        platformType: getBrowserName(),
        access_token: token,
      }),
    })
  );
};